import React, { useEffect } from 'react';

import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useFindWorkflowVersionByEntity } from '../../workflow/Workflow.hooks';
import WorkflowStatusSelector, {
  WorkflowStatusSelectorProps
} from '../../workflow/components/WorkflowStatusSelector';

export type SporStatusFilterProps = Pick<
  WorkflowStatusSelectorProps,
  'value' | 'onChange'
>;

const SporStatusFilter: React.FC<SporStatusFilterProps> = (
  props: SporStatusFilterProps
) => {
  const {
    workflowVersion,
    isLoading,
    loadingError,
    findWorkflowVersion
  } = useFindWorkflowVersionByEntity(WorkflowEntity.Spor);

  useEffect(() => {
    findWorkflowVersion();
  }, [findWorkflowVersion]);

  return (
    <WorkflowStatusSelector
      {...props}
      error={loadingError}
      isLoading={isLoading}
      workflowVersion={workflowVersion}
      className='status-filter'
      textFieldProps={{ size: 'small' }}
    />
  );
};

export default SporStatusFilter;
